"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16DirectionsLine = function Svg16DirectionsLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.546 4.646l4.808 4.808.033.033c.168.169.37.37.532.561.189.223.44.56.591 1.025a3 3 0 0 1 0 1.854 3.015 3.015 0 0 1-.59 1.025 9.858 9.858 0 0 1-.533.56l-.033.034-4.808 4.808a5.04 5.04 0 0 1-.033.033c-.168.168-.37.37-.561.532-.223.189-.56.44-1.025.591a3 3 0 0 1-1.854 0 3.015 3.015 0 0 1-1.025-.59c-.191-.164-.392-.365-.56-.533a10.092 10.092 0 0 1-.034-.033l-4.808-4.808a9.193 9.193 0 0 0-.033-.033c-.168-.168-.37-.37-.532-.561a3.016 3.016 0 0 1-.591-1.025 3 3 0 0 1 0-1.854c.151-.465.402-.803.59-1.025a9.87 9.87 0 0 1 .533-.56l.033-.034 4.808-4.808.033-.033c.169-.168.37-.37.561-.532.223-.189.56-.44 1.025-.591a3 3 0 0 1 1.854 0c.465.151.803.402 1.025.59.191.164.393.365.56.533l.034.033zm-2.855.746c-.228.074-.426.272-.822.668L6.06 10.87c-.396.396-.594.594-.668.822a1 1 0 0 0 0 .618c.074.228.272.426.668.822l4.809 4.809c.396.396.594.594.822.668a1 1 0 0 0 .618 0c.228-.074.426-.272.822-.668l4.809-4.809c.396-.396.594-.594.668-.822a1 1 0 0 0 0-.618c-.074-.228-.272-.426-.668-.822L13.13 6.06c-.396-.396-.594-.594-.822-.668a1 1 0 0 0-.618 0z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    d: "M12.134 12a1 1 0 0 0 1.573 1.207l1.5-1.5a1 1 0 0 0 0-1.414l-1.5-1.5A1 1 0 0 0 12.134 10h-.566c-.252 0-.498 0-.706.017a2.02 2.02 0 0 0-.77.201 2 2 0 0 0-.874.874 2.022 2.022 0 0 0-.201.77C9 12.07 9 12.316 9 12.568V14a1 1 0 1 0 2 0v-1.4c0-.296 0-.459.01-.575l.002-.014h.013c.116-.01.278-.011.575-.011h.534z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16DirectionsLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16DirectionsLine;
exports.default = _default;